import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { usePeriodosQuery } from '../graphql/queries/periodos.query';
import { PeriodosQuery_periodos } from '../graphql/queries/__generated__/PeriodosQuery';
import { useProfessorPageLazyQuery } from '../graphql/queries/professor_page.query';
import { Loading } from '../../shared/components/layout_components/loading';
import { ItemProps } from '../../shared/components/button_select/modal';
import { ProfessorAlocacoes } from '../components/professor_alocacoes';
import { ProfessorInfo } from '../components/professor_infos';
import { Container } from '../components/container/styles';

const ProfessorPage: React.FC = () => {
  const [periodos, setPeriodos] = useState<PeriodosQuery_periodos[]>();
  const [periodo, setPeriodo] = useState<PeriodosQuery_periodos>();

  const [periodosModal, setPeriodosModal] = React.useState(false);

  const { id_professor } = useParams();

  const { data: dados_periodos } = usePeriodosQuery();
  const [obter_dados_professor, { data: dados_professor }] = useProfessorPageLazyQuery();

  const alternar_modal = {
    periodos: () => setPeriodosModal(!periodosModal),
  };

  const selecionar = {
    periodo: (item: ItemProps<PeriodosQuery_periodos>) => {
      setPeriodo(item.data);
      alternar_modal.periodos();
    },
  };

  useEffect(() => {
    if (periodo && id_professor) {
      obter_dados_professor({
        variables: {
          id_professor: Number(id_professor),
          dat_inicio: periodo.dat_inicio,
          dat_fim: periodo.dat_fim,
        },
      });
    }
  }, [periodo]);

  useEffect(() => {
    const periodo_inicial = {
      id_periodo: 0,
      dsc_periodo: 'Todos os períodos',
      dat_fim: '',
      dat_inicio: '',
      __typename: 'periodo',
    } as PeriodosQuery_periodos;

    setPeriodo(periodo_inicial);

    if (dados_periodos) {
      setPeriodos([periodo_inicial, ...dados_periodos.periodos]);
    }
  }, [dados_periodos]);

  useEffect(() => {
    if (dados_professor?.professor) {
      document.title = `SisIEC - Professor - ${dados_professor.professor.dsc_nome_professor}`;
    }
  }, [dados_professor?.professor]);

  return dados_professor ? (
    <Container scroll wide_padding>
      <ProfessorInfo professor={dados_professor.professor} />
      <ProfessorAlocacoes
        alocacoes={dados_professor.alocacoes_professor}
        periodos={periodos}
        periodo={periodo}
        on_periodo_change={selecionar.periodo}
      />
    </Container>
  ) : (
    <Loading />
  );
};

export { ProfessorPage };
